module.exports = __webpack_public_path__ + "img/notifications--icon.ee6ae4fd.svg";